const TiposMutationAuth = {
    SET_STATUS_LOGIN: "SET_STATUS_LOGIN",
    SET_USUARIO_LOGADO: "SET_USUARIO_LOGADO",
};

Object.freeze(TiposMutationAuth);

export default TiposMutationAuth;
